






























	import AbpBase from "../../../lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
    InsertAssayCategory,
    UpdateAssayCategory,
    GetAssayCategory,
    GetAssayCategoryGroupList,
} from '../../../api/basicDictionary'
@Component
export default class extends AbpBase {
    @Prop() value: boolean;
    @Prop() data: any;
    form: any = {};
    dialogTitle: string = "";
    groupList: any = [];
    rules = {
        name: [{ required: true, message: "请输入内容", trigger: "blur" }],
    };

    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
            (this.$refs.form as any).resetFields();
        }
    }

    cancel() {
        this.$emit("input", false);
    }

    created() {
        if (this.data.mode === "add") {
            this.dialogTitle = "新增化验大类";
        } else {
            this.dialogTitle = "修改化验大类";
        }
        this.getGroupList();
        this.getData();
    }

    async getGroupList() {
        let res = await GetAssayCategoryGroupList();
        this.groupList = res.objects;
    }

    async confirm() {
        (this.$refs.form as any).validate(async (valid: boolean) => {
            if (valid) {
                if (this.data.mode === "add") {
                    if(this.form.groupName!="质控上报") this.form.isCanDelete=true
                    await InsertAssayCategory(this.form);
                } else {
                    await UpdateAssayCategory(this.form);
                }
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }

    async getData() {
        if (this.data.item) {
            let res = await GetAssayCategory({ id: this.data.item.id });
            this.form = res.objects;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/assayCategory/addOrEditCate.vue